/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TCActionListResponse } from '../models/TCActionListResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AutomationsActionsService {
    /**
     * List all actions for the tenant
     * @param limit
     * @param pageToken
     * @param includeHidden
     * @returns TCActionListResponse Ok
     * @throws ApiError
     */
    public static listActions(
        limit?: number,
        pageToken?: string,
        includeHidden?: boolean,
    ): CancelablePromise<TCActionListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/automations/actions',
            query: {
                'limit': limit,
                'pageToken': pageToken,
                'includeHidden': includeHidden,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
